import { CACHE_TAG_DISPOSAL_SITE_LIST } from '../cacheTagTypes'
import api from '../index'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    // deprecated, use getDisposalSiteList instead
    getDisposalSites: builder.mutation({
      query: () => ({ url: '/api/settings/disposal/site/list', method: 'POST', body: {} }),
    }),
    getDisposalSiteList: builder.query({
      query: () => ({ url: '/api/settings/disposal/site/list', method: 'POST', body: {} }),
      providesTags: [CACHE_TAG_DISPOSAL_SITE_LIST],
    }),
  }),
})

export const { useGetDisposalSitesMutation, useGetDisposalSiteListQuery, useLazyGetDisposalSiteListQuery } = extendedApi
